import { DO_NOT_USE_FaWrapper } from '../../../v2/foundation/falcon/do-not-use-fa-wrapper/index.js';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { addMonths } from 'date-fns';
import { useCalendar } from '../../Context.js';
import { jsx } from 'react/jsx-runtime';
import { IconButton } from '../../../v2/navigation/buttons/IconButton/IconButton.js';

function NextMonthButton() {
  var _jsx2;
  var _useCalendar = useCalendar(),
    timeZone = _useCalendar.timeZone,
    locale = _useCalendar.locale,
    focusedDate = _useCalendar.focusedDate,
    setFocusedDate = _useCalendar.setFocusedDate,
    yearPickerVisible = _useCalendar.yearPickerVisible;
  var nextMonth = addMonths(focusedDate, 1);
  var handleClick = function handleClick() {
    return setFocusedDate(nextMonth);
  };
  var ariaFormat = new window.Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'long',
    timeZone: timeZone
  });
  if (yearPickerVisible) {
    return null;
  }
  return /*#__PURE__*/jsx(IconButton, {
    type: "button",
    appearance: "ghost",
    size: "small",
    "aria-label": ariaFormat.format(nextMonth),
    onClick: handleClick,
    children: /*#__PURE__*/jsx(DO_NOT_USE_FaWrapper, (_jsx2 = {
      icon: "chevron-right"
    }, _jsx2["icon"] = faChevronRight, _jsx2))
  });
}

export { NextMonthButton };
